sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var StandIns = BlockBase.extend("com.reply.leaviosa.blocks.standIns.StandIns", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.standIns.StandIns",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.standIns.StandIns",
					type: ViewType.XML
				}
			}
		}
	});
    
	return StandIns;
});